import { useMemo } from 'react'

import { useTariffs } from '@/api/models/parking'
import { TariffType } from '@/api/models/parking/lib/parking.types'

const TAB_OPTIONS = [
  { key: TariffType.Daily, title: 'По дням' },
  { key: TariffType.Hourly, title: 'По часам' }
]

export const useParkingTariffs = (
  selectedTab: TariffType,
  selectedIntervalCount: number
) => {
  const { data: tariffs, isLoading, isError } = useTariffs()

  const tabs = useMemo(
    () =>
      TAB_OPTIONS.filter(tab =>
        (tariffs ?? []).some(tariff => tariff.tariffType === tab.key)
      ),
    [tariffs]
  )

  const priceForInterval = useMemo(
    () =>
      tariffs
        ?.find(tariff => tariff.tariffType === selectedTab)
        ?.tariffs.findLast(
          tariff => tariff?.validFrom <= selectedIntervalCount + 1
        )?.price ?? 0,
    [tariffs, selectedTab, selectedIntervalCount]
  )

  return { tariffs, isLoading, isError, tabs, priceForInterval }
}
